(() => {
    // parallax background effects for CTA large image and gallery widget to mimic background attachment
    // fixed and resolve IOS parallax bug
    const parallaxBg = document.querySelectorAll(".block__parallaxBg");
    const handleInViewParallaxEffects = () => {
        parallaxBg.forEach(bg => {
            const parentElm = bg.parentElement;
            const inView = window.innerHeight > parentElm.getBoundingClientRect().top && parentElm.getBoundingClientRect().bottom > 0;
            if (inView) {
                // figure out the percentage to the bottom of the parent element container then adjust the background position by that percentage
                // if negative don't offset the bg image anymore to avoid the upward motion after the animation is complete
                if(parentElm.getBoundingClientRect().bottom - parentElm.getBoundingClientRect().height < 0) {
                    bg.style.backgroundPosition = `0% 0%`;
                    return;
                }
                const percentageToBottomOfParentElm = (Math.abs(parentElm.getBoundingClientRect().bottom - parentElm.getBoundingClientRect().height) / parentElm.getBoundingClientRect().height) * 100;
                let offset = percentageToBottomOfParentElm;
                offset = offset > 100 ? 100 : offset;
                bg.style.backgroundPosition = `0% ${offset}%`;
            }
            else {
                if (parentElm.getBoundingClientRect().bottom > 0) {
                    // reset to original background positioning
                    if (bg.style.backgroundPosition !== "") {
                        bg.style.backgroundPosition = "";
                    }
                }
            }
        });
    }

    handleInViewParallaxEffects();
    window.addEventListener("scroll", handleInViewParallaxEffects, { passive: true });
})();